import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { UniDriverList } from '@wix/unidriver-core';

export interface CarouselWIPUniDriver extends BaseUniDriver {
  isLoading: () => Promise<boolean>;
  getChildren: () => UniDriverList;
  getImages: () => Promise<string | null>[];
  clickNext: () => Promise<void>;
  clickPrevious: () => Promise<void>;
}
